var React = require('react');

function RightQuote (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon / Quote"},React.createElement("path",{"id":"Icon / Quote_2","d":"M40 0V8.14371C40 10.6587 39.5314 13.2535 38.5942 15.9281C37.6145 18.6427 36.2726 21.2176 34.5687 23.6527C32.8222 26.1277 30.8413 28.2435 28.6262 30L20.9585 25.509C22.6624 22.994 24.0682 20.3393 25.1757 17.5449C26.2407 14.7904 26.7732 11.6766 26.7732 8.20359V0H40ZM19.0415 0V8.14371C19.0415 10.6587 18.573 13.2535 17.6358 15.9281C16.656 18.6427 15.3142 21.2176 13.6102 23.6527C11.8637 26.1277 9.88285 28.2435 7.66773 30L0 25.509C1.70394 22.994 3.10969 20.3393 4.21725 17.5449C5.28222 14.7904 5.8147 11.6766 5.8147 8.20359V0H19.0415Z","fill":"#527A66"})));
}

RightQuote.defaultProps = {"width":"40","height":"30","viewBox":"0 0 40 30","fill":"none"};

module.exports = RightQuote;

RightQuote.default = RightQuote;
